var browserHistory = {

	/**
	 * Init
	 *
	 * @param {object} target
	 * @returns {void}
	 */
	init: function(target) {

		target.addEventListener('click', function(event) {
			for (var eventTarget = event.target; eventTarget && eventTarget != this; eventTarget = eventTarget.parentNode) {
				if (eventTarget.matches('[data-browser-history-back]')) {
					browserHistory.historyBack();
					break;
				}
			}
		}, false);

		target.addEventListener('click', function(event) {
			for (var eventTarget = event.target; eventTarget && eventTarget != this; eventTarget = eventTarget.parentNode) {
				if (eventTarget.matches('[data-browser-history-forward]')) {
					browserHistory.historyForward();
					break;
				}
			}
		}, false);

	},

	/**
	 * Navigate browser history back
	 *
	 * @returns {void}
	 */
	historyBack: function() {
		window.history.back();
	},

	/**
	 * Navigate browser history forward
	 *
	 * @returns {void}
	 */
	historyForward: function() {
		window.history.forward();
	},
};

export default browserHistory;
